import { Box } from '@mui/material'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SelectLocale } from '@/features/select-locale'
import { SupportButton, SupportInfo } from '@/widgets/support-info-widget'

export const Route = createFileRoute('/_login')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'fixed', top: '24px', right: '40px' }}>
        <SelectLocale />
      </Box>

      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: '16px', sm: '40px' },
          right: { xs: '16px', sm: '40px' },
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: '16px', sm: '32px' },
        }}
      >
        <SupportInfo />
        <SupportButton />
      </Box>

      <Outlet />
    </Box>
  )
}
